import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
	const theme = useTheme();
	const PRIMARY_LIGHT = theme.palette.primary.light;
	const PRIMARY_MAIN = theme.palette.primary.main;
	const PRIMARY_DARK = theme.palette.primary.dark;
	const logo = (
		<Box sx={{ width: 40, height: 40, ...sx }}>
			<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 1080.000000">
				<defs>
					<linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
						<stop offset="0%" stopColor={PRIMARY_DARK} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
					<linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
						<stop offset="0%" stopColor={PRIMARY_LIGHT} />
						<stop offset="100%" stopColor={PRIMARY_MAIN} />
					</linearGradient>
				</defs>
				<g
					fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >
				<path d="M5080 7394 c-41 -7 -96 -19 -121 -28 -116 -36 -266 -127 -358 -215
-49 -49 -61 -54 -171 -86 -237 -68 -344 -126 -409 -223 -18 -26 -23 -46 -22
-97 0 -76 25 -126 97 -201 24 -24 44 -52 44 -60 0 -8 -14 -27 -31 -41 -16 -14
-28 -32 -25 -39 3 -7 0 -15 -7 -17 -17 -6 26 -50 88 -91 36 -24 54 -45 64 -72
13 -36 67 -133 81 -144 3 -3 17 -21 30 -40 13 -19 29 -39 35 -43 6 -5 4 -7 -5
-5 -19 5 -140 155 -140 174 0 25 -36 15 -96 -25 -114 -76 -197 -176 -230 -273
-22 -68 -16 -187 14 -248 23 -48 131 -173 132 -153 0 6 -4 15 -10 18 -15 10
-12 23 8 28 15 4 15 5 -2 6 -15 1 -14 6 13 37 17 19 29 40 25 46 -4 7 2 8 17
3 l24 -7 -24 21 c-34 29 -17 26 38 -7 25 -16 64 -34 86 -41 22 -7 49 -16 60
-21 71 -29 188 -57 300 -70 186 -23 398 -40 507 -40 100 0 122 -3 152 -21 39
-23 42 -29 24 -47 -9 -9 -9 -12 1 -12 7 0 9 -4 6 -10 -3 -5 0 -10 8 -10 17 0
28 -32 17 -50 -4 -7 -13 -9 -20 -5 -9 5 -11 4 -6 -3 4 -7 14 -12 22 -12 8 0
14 -4 14 -10 0 -5 -8 -10 -17 -10 -10 0 -61 -5 -113 -10 -52 -6 -188 -10 -302
-10 -115 0 -208 -2 -208 -6 0 -15 43 -64 51 -58 6 3 27 -5 48 -19 55 -36 127
-71 201 -97 63 -21 225 -53 265 -51 11 1 45 1 75 2 30 0 64 4 75 8 11 5 56 18
100 30 82 22 181 66 247 109 20 13 41 21 47 18 5 -4 24 12 42 34 30 37 36 40
83 40 33 0 62 7 84 20 51 31 92 109 77 147 -6 15 -9 13 -22 -12 -9 -17 -18
-25 -20 -17 -6 17 -23 15 -23 -3 0 -37 -84 5 -100 49 -13 36 -13 96 -1 96 5 0
11 10 13 21 4 25 79 61 86 41 2 -7 10 -12 18 -12 8 0 14 -6 14 -13 0 -7 9 -18
21 -25 18 -11 23 -11 35 5 7 10 16 26 20 36 9 27 34 2 34 -34 0 -15 5 -31 10
-34 6 -3 10 -33 10 -66 0 -36 4 -59 11 -59 19 0 171 75 233 115 112 71 197
179 192 240 -6 54 -18 105 -26 105 -16 0 -20 33 -7 49 15 18 44 106 53 162 19
117 -94 242 -275 304 -61 21 -92 19 -98 -5 -3 -11 -9 -20 -14 -20 -15 0 -10
-85 6 -121 l16 -34 -4 39 -3 38 33 -5 c50 -9 141 -53 190 -93 31 -26 43 -31
43 -19 0 12 4 14 20 5 22 -12 37 -74 22 -93 -5 -6 -13 -37 -17 -67 -4 -30 -14
-68 -23 -85 -21 -42 -121 -136 -168 -159 -21 -10 -48 -23 -59 -29 -41 -22
-115 -57 -121 -57 -8 0 3 63 21 115 21 64 56 239 58 294 1 37 -3 55 -15 68
-17 16 -18 16 -18 -5 0 -31 -35 -160 -62 -228 -20 -50 -57 -99 -99 -129 -8 -6
-33 -9 -57 -9 -35 2 -41 0 -32 -11 9 -11 1 -13 -42 -12 -61 0 -68 -1 -125 -31
-24 -12 -43 -20 -43 -16 0 3 -12 -1 -26 -11 -21 -13 -28 -14 -34 -4 -7 10 -14
10 -38 0 -42 -18 -173 -7 -237 19 -80 32 -107 45 -116 57 -6 7 -17 13 -25 13
-7 0 -30 11 -51 25 -41 26 -41 27 -77 65 -12 14 -32 33 -44 42 -27 21 -28 36
-4 45 46 18 68 76 50 135 -18 61 -2 69 149 85 197 20 316 42 331 61 11 14 11
18 -2 20 -20 4 -26 26 -16 61 4 16 6 32 2 35 -3 3 3 6 12 6 12 0 16 5 12 15
-5 15 21 25 120 44 86 17 298 79 382 111 132 51 249 137 319 235 l22 30 -1
-38 c-1 -20 2 -40 7 -45 4 -4 6 3 3 14 -7 26 8 57 16 34 2 -8 7 -22 9 -30 3
-8 6 20 6 62 3 225 -149 351 -464 388 -112 12 -166 12 -185 0 -12 -8 -7 -18
32 -56 l47 -47 52 16 c28 9 64 17 81 17 35 0 107 -35 115 -56 8 -21 107 -64
132 -57 13 3 21 1 21 -7 0 -7 -7 -10 -15 -7 -8 4 -17 1 -21 -5 -4 -6 -3 -8 3
-5 6 4 16 0 23 -8 18 -21 30 -19 30 6 0 12 5 19 13 16 6 -2 11 -11 11 -20 -1
-9 2 -14 7 -11 16 9 31 -49 25 -96 -12 -85 -69 -169 -153 -225 -43 -28 -73
-28 -73 0 0 21 -27 19 -57 -5 -30 -23 -205 -80 -343 -110 -82 -18 -344 -55
-420 -59 -14 0 -106 -4 -205 -8 l-180 -8 3 -25 c2 -14 4 -63 5 -110 2 -47 6
-93 11 -102 4 -9 5 -21 2 -26 -5 -9 23 -40 31 -34 1 1 6 2 10 2 4 0 -3 -7 -15
-16 -21 -15 -27 -37 -8 -34 30 5 47 -80 22 -113 -13 -16 -15 -16 -37 2 -18 14
-24 29 -24 62 -2 56 -13 89 -30 89 -9 0 -14 15 -15 45 -1 69 -3 75 -13 75 -5
0 -17 -10 -26 -21 -16 -20 -21 -21 -54 -10 -43 14 -48 21 -57 73 -6 32 -5 38
10 38 12 0 17 7 16 23 -1 18 4 22 29 22 20 0 35 -8 46 -23 l16 -22 12 24 c11
20 10 30 -8 71 -23 52 -25 58 -13 52 4 -3 7 33 7 79 0 64 4 87 15 95 11 8 12
12 3 16 -18 7 -16 52 2 59 8 4 15 15 15 27 0 11 6 28 13 36 8 9 22 36 31 61
10 25 27 61 39 80 12 19 21 38 20 41 -1 3 14 21 32 39 19 19 35 38 35 43 0 12
152 157 165 157 6 0 28 19 49 41 l38 42 107 1 c107 1 139 -6 223 -50 14 -8 33
-14 42 -14 9 0 16 -5 16 -12 0 -6 3 -9 6 -5 4 3 -3 17 -14 31 -10 14 -22 23
-25 20 -3 -3 -25 7 -49 23 -156 106 -393 153 -598 117z m-39 -201 c-12 -20
-14 -14 -5 12 4 9 9 14 11 11 3 -2 0 -13 -6 -23z m-197 -9 c13 -34 7 -54 -18
-54 -24 0 -36 16 -36 51 0 24 45 27 54 3z m170 -36 c-3 -12 -13 -28 -20 -36
-8 -7 -14 -17 -14 -22 0 -5 -12 -35 -26 -67 -28 -63 -67 -148 -90 -201 -13
-31 -13 -35 11 -66 49 -65 17 -134 -49 -105 -43 20 -54 80 -21 119 7 8 31 56
53 105 44 96 150 295 158 295 3 0 2 -10 -2 -22z m-609 -235 c-3 -16 -17 -42
-30 -58 -24 -32 -72 -158 -106 -280 -11 -38 -24 -74 -28 -78 -25 -25 -138 74
-180 158 -38 73 -38 89 -5 140 l25 40 -5 -37 -5 -38 22 21 c70 67 191 127 316
158 2 1 0 -11 -4 -26z m346 -376 c-16 -16 -26 0 -10 19 9 11 15 12 17 4 2 -6
-1 -17 -7 -23z m369 -407 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15
10 8 0 15 -4 15 -10z m-884 -109 c9 -76 65 -280 98 -356 8 -16 16 -45 19 -62
8 -38 -1 -41 -59 -17 -161 65 -243 129 -265 204 -7 25 -19 51 -26 58 -15 16
-17 41 -3 62 7 11 10 6 10 -20 l1 -35 22 43 c28 54 69 98 127 134 55 35 72 33
76 -11z m453 -305 c17 -21 31 -43 31 -49 0 -9 -45 48 -65 83 -12 21 -1 11 34
-34z m329 -160 c3 -12 -1 -17 -10 -14 -7 3 -15 13 -16 22 -3 12 1 17 10 14 7
-3 15 -13 16 -22z"/>
<path d="M6030 7050 c0 -5 8 -10 19 -10 10 0 40 -3 67 -6 46 -6 48 -5 29 9
-22 18 -115 23 -115 7z"/>
<path d="M5496 6918 c-9 -12 -16 -33 -16 -45 0 -28 33 -63 59 -63 30 0 34 17
6 24 -28 7 -41 41 -31 81 8 31 2 32 -18 3z"/>
<path d="M5614 6825 c21 -16 32 -13 21 4 -3 6 -14 11 -23 11 -15 -1 -15 -2 2
-15z"/>
<path d="M4081 5534 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M5694 5078 l-19 -21 28 18 c28 18 33 25 19 25 -5 0 -17 -10 -28 -22z"/>
<path d="M5640 5040 c-9 -6 -10 -10 -3 -10 6 0 15 5 18 10 8 12 4 12 -15 0z"/>
<path d="M5555 5004 l-30 -14 30 6 c17 3 34 10 40 15 14 13 -5 11 -40 -7z"/>
<path d="M4968 4923 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5098 4923 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3872 4541 c-2 -27 -19 -63 -52 -116 -10 -16 -29 -50 -42 -75 -12
-25 -30 -56 -40 -69 -22 -29 -23 -47 -3 -55 28 -10 45 6 76 72 18 36 45 86 60
111 22 35 29 57 29 97 0 33 -5 54 -13 57 -8 3 -14 -5 -15 -22z"/>
<path d="M6599 4543 c-1 -10 0 -30 1 -45 1 -26 -1 -28 -38 -28 -23 0 -45 6
-52 15 -17 21 -37 19 -50 -5 -14 -26 -7 -37 37 -55 46 -19 62 -19 85 2 10 9
21 13 25 9 4 -3 8 -51 10 -105 4 -120 19 -169 63 -198 39 -27 121 -31 175 -9
46 20 49 49 3 35 -51 -14 -106 0 -143 37 -36 36 -41 53 -51 206 -4 69 -10 98
-20 102 -8 3 -14 17 -14 31 0 28 -29 36 -31 8z"/>
<path d="M6787 4553 c-4 -3 -7 -15 -7 -25 0 -10 -5 -27 -12 -37 -9 -15 -8 -24
5 -44 12 -18 18 -54 20 -119 2 -51 5 -93 8 -92 46 7 49 11 48 71 0 56 -11 153
-25 221 -6 30 -22 41 -37 25z"/>
<path d="M6960 4531 c0 -16 -6 -31 -15 -35 -19 -7 -19 -35 -1 -55 19 -22 27
-222 8 -229 -13 -4 -17 -88 -4 -95 4 -3 69 -2 145 2 119 6 140 9 157 27 l20
20 -132 0 -133 -1 -3 38 c-2 24 1 37 9 37 9 0 10 31 7 122 -5 104 -8 123 -24
135 -12 9 -18 23 -16 38 2 14 -1 25 -7 25 -6 0 -11 -13 -11 -29z"/>
<path d="M5524 4536 c-3 -7 -4 -40 -2 -72 3 -56 5 -59 30 -62 17 -2 34 4 47
17 12 12 23 21 26 21 2 0 6 -46 7 -102 4 -151 23 -127 23 30 0 122 -1 127 -21
130 -15 2 -23 -3 -27 -17 -3 -15 -13 -21 -31 -21 -24 0 -26 3 -26 45 0 43 -15
61 -26 31z"/>
<path d="M5892 4538 c-5 -7 -13 -28 -17 -45 -5 -26 -12 -33 -30 -33 -14 0 -25
7 -28 20 -3 12 -14 20 -27 20 -21 0 -22 -4 -17 -41 6 -47 19 -59 61 -59 28 0
28 -1 22 -40 -19 -121 -19 -125 -6 -113 7 7 17 31 21 55 18 97 38 195 44 221
8 28 -5 37 -23 15z"/>
<path d="M3667 4503 c-4 -3 -7 -15 -7 -25 0 -14 -8 -18 -35 -18 -39 0 -46 -17
-19 -45 27 -26 65 -15 95 30 15 21 25 45 22 52 -5 14 -45 18 -56 6z"/>
<path d="M4295 4500 c-9 -14 15 -54 26 -43 10 10 1 53 -12 53 -4 0 -11 -4 -14
-10z"/>
<path d="M4812 4498 c-14 -14 -16 -45 -3 -53 5 -3 17 2 25 11 15 14 17 14 32
0 20 -20 34 -12 34 19 0 25 -29 43 -41 23 -6 -9 -11 -9 -21 0 -11 9 -17 9 -26
0z"/>
<path d="M5017 4503 c-4 -3 -7 -16 -7 -28 0 -15 9 -24 33 -30 32 -10 32 -10
38 -90 l5 -80 2 96 c1 63 -2 100 -10 111 -15 19 -51 31 -61 21z"/>
<path d="M6312 4493 c-17 -32 -23 -74 -16 -108 8 -45 68 -115 99 -115 12 0 28
-7 35 -16 19 -22 64 -14 68 12 2 16 -9 26 -53 48 -78 40 -105 75 -105 136 0
52 -13 72 -28 43z"/>
<path d="M7120 4446 c0 -47 3 -56 22 -62 39 -12 63 49 38 97 -6 11 -21 19 -35
19 -24 0 -25 -3 -25 -54z"/>
<path d="M4066 4448 c-25 -91 -25 -93 -12 -107 25 -24 57 59 40 103 -7 19 -23
21 -28 4z"/>
<path d="M4422 4448 c-15 -15 -17 -208 -2 -208 6 0 10 28 10 65 0 48 4 66 16
73 12 7 15 17 9 40 -8 37 -17 46 -33 30z"/>
<path d="M4662 4440 c-5 -14 -13 -40 -16 -57 -4 -18 -12 -35 -17 -38 -5 -4 -9
-14 -9 -23 0 -9 -10 -50 -22 -90 -19 -60 -26 -72 -42 -70 -14 2 -25 19 -37 53
-21 57 -24 33 -6 -35 16 -60 24 -70 53 -70 29 0 32 8 69 140 14 52 33 105 41
117 16 25 18 61 4 83 -7 12 -11 10 -18 -10z"/>
<path d="M5385 4440 c-9 -27 15 -100 33 -100 11 0 13 9 7 46 -11 76 -26 97
-40 54z"/>
<path d="M5983 4453 c-19 -7 -17 -97 2 -113 25 -21 39 2 31 52 -8 51 -16 67
-33 61z"/>
<path d="M4466 4345 c11 -48 25 -76 18 -35 -4 19 -10 42 -15 50 -6 10 -7 5 -3
-15z"/>
<path d="M7132 4338 c-13 -17 -5 -79 12 -96 11 -11 18 -11 35 -3 29 16 30 85
2 101 -26 13 -36 13 -49 -2z"/>
<path d="M5371 4292 c-6 -2 -11 -15 -11 -28 0 -19 5 -24 24 -24 13 0 31 -3 40
-6 20 -8 33 23 19 45 -10 15 -46 22 -72 13z"/>
<path d="M5962 4288 c-22 -22 -14 -48 13 -48 25 0 33 -14 15 -25 -5 -3 -10
-17 -10 -31 0 -23 -2 -24 -69 -24 l-70 0 -3 33 c-2 17 -7 32 -12 32 -6 0 -14
-15 -18 -32 l-9 -33 -84 0 c-83 0 -85 0 -85 24 0 38 -19 41 -31 7 l-11 -31
-78 0 -77 0 -7 33 c-7 30 -8 31 -21 13 -8 -11 -15 -26 -15 -33 0 -10 -20 -13
-75 -13 l-75 0 0 28 c-1 23 -2 25 -11 9 -6 -9 -9 -32 -7 -50 l3 -32 73 -3 c43
-2 79 2 87 8 9 8 15 8 20 0 3 -5 42 -10 90 -10 48 0 87 5 90 10 5 8 11 8 19 1
7 -6 116 -10 281 -10 231 0 273 3 287 16 28 25 12 33 -74 33 l-80 0 5 33 c3
17 9 45 13 61 5 19 2 31 -7 37 -20 12 -53 11 -67 -3z"/>
<path d="M4030 4261 c0 -17 5 -31 10 -31 6 0 10 -16 10 -35 l0 -35 -70 0 -70
0 0 34 c0 44 -9 66 -26 66 -10 0 -14 -14 -14 -50 l0 -50 -137 -1 c-76 -1 -144
-1 -150 0 -16 2 -17 -35 -2 -45 7 -4 109 -6 228 -6 304 2 440 2 449 1 4 -1 50
-1 103 0 105 1 110 4 102 59 -6 35 -23 44 -23 12 0 -18 -7 -20 -76 -20 -67 0
-75 2 -70 18 7 22 -8 47 -23 38 -6 -4 -11 -18 -11 -32 0 -24 -2 -24 -85 -24
-77 0 -85 2 -85 19 0 11 -4 23 -10 26 -20 12 -10 35 16 35 21 0 25 4 22 23 -2
18 -10 23 -45 25 -42 3 -43 2 -43 -27z"/>
<path d="M6310 4241 c-15 -28 -12 -97 4 -110 25 -21 146 -30 198 -14 46 13 78
45 59 57 -5 4 -11 1 -13 -5 -6 -17 -115 -17 -165 0 -41 13 -43 16 -43 53 0 42
-21 53 -40 19z"/>
<path d="M5177 4215 c-31 -43 -80 -56 -202 -55 -60 1 -114 1 -120 0 -5 -1 -53
-2 -105 -3 -88 -2 -95 -4 -95 -22 0 -18 8 -20 93 -23 65 -2 92 1 92 9 0 8 4 8
15 -1 10 -8 52 -11 145 -9 l130 4 34 35 c31 32 56 90 39 90 -5 0 -16 -12 -26
-25z"/>

</g>
</svg>


		</Box >
	);
	if (disabledLink) {
		return <>{logo}</>;
	}

	return <RouterLink to="">{logo}</RouterLink>;
}
